export default "__VITE_PUBLIC_ASSET__c7f79d88__"